import React from "react";
import { Descriptions, Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import "./style.css";

const { Panel } = Collapse;

const customPanelStyle = {
  background: "#f4f4f4",
  borderRadius: 4,
  border: 0,
  overflow: "hidden",
  marginBottom: "3px",
};

const TopContent = () => {
  return (
    <Collapse
      bordered={false}
      style={{
        padding: "0",
        marginTop: "10px",
        width: "100%",
        backgroundColor: "#ffff",
      }}
      className="grid-container"
      defaultActiveKey={["1"]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined type="caret-right" rotate={isActive ? 90 : 0} />
      )}
    >
      <Panel
        header="CONTRACT DETAILS"
        key="1"
        className="grid-item"
        style={customPanelStyle}
      >
        <Descriptions layout={"vertical"}>
          <Descriptions.Item
            label="Contract Description"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            Upgrading of CBD Roads
          </Descriptions.Item>
          <Descriptions.Item
            label="Contractor Name"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            CRJE East Africa
          </Descriptions.Item>
          <Descriptions.Item
            label="Contract Sum (TZS)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            150,000,000
          </Descriptions.Item>
          <Descriptions.Item
            label="Contractor Name"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            CRJE East Africa
          </Descriptions.Item>
          <Descriptions.Item
            label="Revised Contract Sum (TZS)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            190,000,000
          </Descriptions.Item>
          <Descriptions.Item
            label="Contract Period (Months)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            10
          </Descriptions.Item>
        </Descriptions>
      </Panel>
      <Panel
        header="WORK SUMMARY"
        key="2"
        className="grid-item"
        style={customPanelStyle}
      >
        <Descriptions layout={"vertical"}>
          <Descriptions.Item
            label="Package Number"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            1
          </Descriptions.Item>
          <Descriptions.Item
            label="Works Category"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            Roads
          </Descriptions.Item>
          <Descriptions.Item
            label="End of Defect Liability Period(DLP)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            20/09/2026
          </Descriptions.Item>
          <Descriptions.Item
            label="Commencement Date"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            12/09/2000
          </Descriptions.Item>
          <Descriptions.Item
            label="Original Completion Date"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            12/12/2021
          </Descriptions.Item>
          <Descriptions.Item
            label="Revised Completion Date"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            10/12/2022
          </Descriptions.Item>
        </Descriptions>
      </Panel>
      <Panel
        header="TIME EXTENSION"
        key="3"
        className="grid-item"
        style={customPanelStyle}
      >
        <Descriptions layout={"vertical"}>
          <Descriptions.Item
            label="Extension of Time(EOT) applied (Days)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            123
          </Descriptions.Item>
          <Descriptions.Item
            label="Extension of Time Granted (Days)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            65
          </Descriptions.Item>
          <Descriptions.Item
            label="Justification for EOT"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            Now eldest new tastes plenty mother called misery get. Longer excuse
            for county nor except met its things.
          </Descriptions.Item>
        </Descriptions>
      </Panel>
      <Panel
        header="AMOUNT(TZS)"
        key="4"
        className="grid-item"
        style={customPanelStyle}
      >
        <Descriptions layout={"vertical"}>
          <Descriptions.Item
            label="Advance Recovery Amount(TZS)"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            123,789,000
          </Descriptions.Item>
          <Descriptions.Item
            label="Deduction of Retention Amount"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            653,678,999
          </Descriptions.Item>
        </Descriptions>
      </Panel>
      <Panel
        header="MOBILISATIONS"
        key="5"
        className="grid-item"
        style={customPanelStyle}
      >
        <Descriptions layout={"vertical"}>
          <Descriptions.Item
            label="Mobilisation of Key Staff"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            Full mobilisation
          </Descriptions.Item>
          <Descriptions.Item
            label="Equipment Mobilization"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            Full mobilisation
          </Descriptions.Item>
          <Descriptions.Item
            label="Material Mobilization"
            labelStyle={{ fontWeight: "bolder", color: "#0f6788" }}
          >
            80% mobilisation
          </Descriptions.Item>
        </Descriptions>
      </Panel>
    </Collapse>
  );
};

export default TopContent;
